import { render, staticRenderFns } from "./ownerList.vue?vue&type=template&id=1294f87e"
import script from "./ownerList.vue?vue&type=script&lang=js"
export * from "./ownerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports